export const JWT_TOKEN = 'jwtTokenFunders'
export const REFRESH_TOKEN = 'refreshTokenFunders'
export const USER_ROLE = 'userRole'
